// M8.3 Finance — cost ledger, rate card, exports, and anomalies at
// /v2/finance/*. Classification: observational. No action nudges.
// Attention marks are not wired on this surface.
//
// Strict `=== 'true'`. Unset / 'false' / '1' / 'yes' / 'TRUE' stay off.
// App.tsx keeps the same comparison inline so a flag-off build drops
// the route. This helper is that comparison for the page bail-out
// and the second conjunct on the route.
export function isFinanceV2Enabled(): boolean {
  return import.meta.env.VITE_FINANCE_V2_ENABLED === 'true';
}
